function open(sharethis) {
    sharethis.classList.add('fpaPage__sharethis--open');
}

function close(sharethis) {
    sharethis.classList.remove('fpaPage__sharethis--open');
}

function initSharethis(sharethis) {
    const openButton = sharethis.querySelector('.js_openSharethis');
    const closeButton = sharethis.querySelector('.js_closeSharethis');

    if (openButton && closeButton) {
        openButton.addEventListener('click', e => open(sharethis));
        closeButton.addEventListener('click', e => close(sharethis));
    }
}

function init() {
    const sharethis = [...document.querySelectorAll('.js_sharethis')];

    sharethis.forEach(initSharethis);
}

$(document).ready(init);
